'use strict';

var getSymbolDescription = require('es-abstract/helpers/getSymbolDescription');

module.exports = function description() {
	return getSymbolDescription(this);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/symbol.prototype.description/implementation.js
// module id = 1168
// module chunks = 31